import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import useAuth from "hooks/useAuth";

const TrackPageView = () => {
  const location = useLocation();
  const { state } = useAuth();
  // eslint-disable-next-line no-unused-vars
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const checkAndTrackPageView = () => {
      const tabName = document.title;

      if (tabName.includes("Loading")) {
        return false;
      }

      const params = new URLSearchParams(location.search);
      const hw_id = params.get("hw_id");
      const apiKey = params.get("apiKey");

      const userId =
      hw_id ||
      apiKey ||
      (state.isAuthenticated ? state.currentUser?.userId : null);

      window.gtag('set', { user_id: userId });
      ReactGA.set({ user_id: userId });

      window.gtag('event', 'page_view', {
        page_title: tabName,
        page_path: location.pathname + location.search,
      });
      console.log('gtag event:', {
        page_title: tabName,
        page_path: location.pathname + location.search, 
      });

      ReactGA.send({
        hitType: "pageview",
        title: tabName,
        page_path: location.pathname + location.search,
      });

      setInitialized(true);
      return true;
    };

    const interval = setInterval(() => {
      if (checkAndTrackPageView()) {
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [location, state]);

  return null;
};

export default TrackPageView;
